const csInquiryToastMsg = {
  /**
   *  [1:1 문의 리스트] 1:1 문의 리스트 요청하기
   */
  GET_INQUIRY_LIST_REQUEST_SUCCESS: '1:1 문의 리스트 요청하기 성공',
  GET_INQUIRY_LIST_REQUEST_ERROR: '1:1 문의 리스트 요청하기 실패',

  /**
   *  [1:1 문의 리스트] 1:1 문의 리스트 excel 다운로드
   */
  GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '1:1 문의 리스트 excel 다운로드 요청하기 성공',
  GET_INQUIRY_EXCEL_DOWNLOAD_REQUEST_ERROR: '1:1 문의 리스트 excel 다운로드 요청하기 실패',

  /**
   *  [1:1 문의 상세] 1:1 문의 상세 요청하기
   */
  GET_INQUIRY_DETAIL_REQUEST_SUCCESS: '1:1 문의 상세 요청하기 성공',
  GET_INQUIRY_DETAIL_REQUEST_ERROR: '1:1 문의 상세 요청하기 실패',

  /**
   *  [1:1 문의 상세] 1:1 문의 답변 작성하기
   */
  REPLY_INQUIRY_DETAIL_REQUEST_SUCCESS: '1:1 문의 답변 작성하기 성공',
  REPLY_INQUIRY_DETAIL_REQUEST_ERROR: '1:1 문의 답변 작성하기 실패',
};

export default csInquiryToastMsg;
